import {
	SigninUserWithOtpPayload,
	SigninWithOtpResponse,
	loginUserWithOtp,
} from "@/api/signin";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export const useSignInUserWithOtp = (
	options?: MutationOptionsWithoutFn<
		SigninWithOtpResponse,
		SigninUserWithOtpPayload
	>,
) => {
	return useMutation({
		mutationFn: loginUserWithOtp,
		...options,
	});
};
